import "./IconQuestion.scss";

export const IconQuestion = () => {
  return <span className="icon-question"></span>;
};
